import i18next from "i18next";
import { dlog } from "@shared/utility.js";
import enUS from "../locales/en_US.json";
import esMX from "../locales/es_MX.json";
import frFR from "../locales/fr_FR.json";
import deDE from "../locales/de_DE.json";
import nlNL from "../locales/nl_NL.json";
import jaJP from "../locales/ja_JP.json";
import koKR from "../locales/ko_KR.json";

function normalizeLocale(locale) {
    return locale.replace("_", "-");
}

const LOCALE_OVERRIDE_KEY = "cyokit-locale-override";

function getCurrentLocale() {
    const override = localStorage.getItem(LOCALE_OVERRIDE_KEY);
    if (override) {
        const normalized = normalizeLocale(override);
        console.warn("CYOKit: Using locale override:", normalized);
        return normalized;
    }
    const container = document.getElementById("cyokit-container");
    const attr = container ? container.getAttribute("locale") : null;
    if (!attr) return "en-US";
    return normalizeLocale(attr);
}

i18next.init({
    lng: getCurrentLocale(),
    fallbackLng: "en-US",
    interpolation: { escapeValue: false },
    resources: {
        "en-US": { translation: enUS },
        "es-MX": { translation: esMX },
        "fr-FR": { translation: frFR },
        "de-DE": { translation: deDE },
        "nl-NL": { translation: nlNL },
        "ja-JP": { translation: jaJP },
        "ko-KR": { translation: koKR }
    }
});

const t = i18next.t.bind(i18next);

let localeLogged = false;

function initLocale() {
    const locale = getCurrentLocale();
    if (!localeLogged) {
        dlog(`i18n locale: ${locale}`);
        localeLogged = true;
    }
    if (locale !== i18next.language) {
        i18next.changeLanguage(locale);
    }
}

function getProductTitle(skuId, fallback) {
    const key = `productTitles.${skuId}`;
    const result = t(key, { defaultValue: "" });
    return result || fallback || "";
}

export { t, initLocale, getProductTitle, getCurrentLocale, LOCALE_OVERRIDE_KEY };
